export interface ZodiacSign {
  key: string;
  title: string;
  symbol: string;
  svgPath: string;
  element: 'fire' | 'earth' | 'air' | 'water';
  elementTitle: string;
  color: string;
  bgGradient: string;
  dates: string;
}

export const ZODIAC_SIGNS: ZodiacSign[] = [
  {
    key: 'aries',
    title: 'Овен',
    symbol: '♈',
    svgPath: 'M22.76 5.5c-1.01 0-1.99.36-2.75 1.02c-.77.65-1.27 1.56-1.43 2.56l-2.41 15.28c-.01.08-.08.14-.17.14c-.08 0-.16-.06-.17-.14L13.42 9.07c-.16-1-.67-1.9-1.43-2.56A4.242 4.242 0 0 0 5 9.74c0 .55.45 1 1 1s1-.45 1-1C7 8.5 8 7.5 9.24 7.5c1.11 0 2.04.79 2.21 1.89l2.41 15.28A2.16 2.16 0 0 0 16 26.5c1.07 0 1.98-.77 2.14-1.83l2.41-15.28c.17-1.09 1.1-1.89 2.21-1.89C24 7.5 25 8.5 25 9.74c0 .55.45 1 1 1s1-.45 1-1c0-2.34-1.9-4.24-4.24-4.24',
    element: 'fire',
    elementTitle: 'Огонь',
    color: '#e53935',
    bgGradient: 'linear-gradient(135deg, #ff5722 0%, #d32f2f 100%)',
    dates: '21 мар – 20 апр'
  },
  {
    key: 'taurus',
    title: 'Телец',
    symbol: '♉',
    svgPath: 'M24 6.5c-2.24 0-4.37.8-6.01 2.25c-.55.48-1.26.75-1.99.75s-1.44-.27-1.99-.75C12.37 7.3 10.24 6.5 8 6.5c-.55 0-1 .45-1 1s.45 1 1 1c1.74 0 3.4.61 4.67 1.73A8.01 8.01 0 0 0 8 17.5c0 4.41 3.59 8 8 8s8-3.59 8-8a8.01 8.01 0 0 0-4.67-7.27C20.6 9.11 22.26 8.5 24 8.5c.55 0 1-.45 1-1s-.45-1-1-1m-2 11c0 3.31-2.69 6-6 6s-6-2.69-6-6s2.69-6 6-6s6 2.69 6 6',
    element: 'earth',
    elementTitle: 'Земля',
    color: '#43a047',
    bgGradient: 'linear-gradient(135deg, #66bb6a 0%, #2e7d32 100%)',
    dates: '21 апр – 21 мая'
  },
  {
    key: 'gemini',
    title: 'Близнецы',
    symbol: '♊',
    svgPath: 'M25.44 24.14c-1.43-.7-2.91-1.24-4.44-1.6V9.46c1.53-.36 3.01-.9 4.44-1.6a1 1 0 0 0 .46-1.34a1 1 0 0 0-1.34-.46A19.2 19.2 0 0 1 16 8.04c-3 0-5.88-.67-8.56-1.98c-.5-.24-1.09-.04-1.34.46c-.24.5-.04 1.09.46 1.34c1.43.7 2.91 1.23 4.44 1.6v13.08c-1.53.36-3.01.9-4.44 1.6a1 1 0 0 0-.46 1.34a1 1 0 0 0 1.34.46A19.2 19.2 0 0 1 16 23.96c3 0 5.88.67 8.56 1.98c.14.07.29.1.44.1c.37 0 .72-.21.9-.56c.24-.5.04-1.09-.46-1.34M13 22.17V9.83q1.485.21 3 .21t3-.21v12.33q-1.485-.21-3-.21c-1.01.01-2.01.08-3 .22',
    element: 'air',
    elementTitle: 'Воздух',
    color: '#0288d1',
    bgGradient: 'linear-gradient(135deg, #29b6f6 0%, #0277bd 100%)',
    dates: '22 мая – 21 июн'
  },
  {
    key: 'cancer',
    title: 'Рак',
    symbol: '♋',
    svgPath: 'M17.06 11.39c0-1.75-.78-3.32-2.01-4.37c3.92.19 7.48 2.25 9.59 5.6c.19.3.51.47.85.47c.18 0 .37-.05.53-.16c.47-.3.61-.91.31-1.38A14.05 14.05 0 0 0 14.45 5c-1.82 0-3.59.34-5.26 1.02c0 0-.01 0-.01.01a5.76 5.76 0 0 0-3.66 5.36c0 3.18 2.59 5.77 5.77 5.77s5.77-2.59 5.77-5.77m-2 0c0 2.08-1.69 3.77-3.77 3.77s-3.77-1.69-3.77-3.77s1.69-3.77 3.77-3.77s3.77 1.69 3.77 3.77 M20.71 14.84c3.18 0 5.77 2.59 5.77 5.77a5.77 5.77 0 0 1-3.66 5.36l-.001.009l-.009.001c-1.67.68-3.44 1.02-5.26 1.02a14.05 14.05 0 0 1-11.88-6.55a.994.994 0 0 1 .31-1.38a.994.994 0 0 1 1.38.31c2.11 3.35 5.67 5.41 9.59 5.6a5.73 5.73 0 0 1-2.01-4.37c0-3.18 2.59-5.77 5.77-5.77m-3.77 5.77c0 2.08 1.69 3.77 3.77 3.77s3.77-1.69 3.77-3.77s-1.69-3.77-3.77-3.77s-3.77 1.69-3.77 3.77',
    element: 'water',
    elementTitle: 'Вода',
    color: '#00897b',
    bgGradient: 'linear-gradient(135deg, #26a69a 0%, #00695c 100%)',
    dates: '22 июн – 22 июл'
  },
  {
    key: 'leo',
    title: 'Лев',
    symbol: '♌',
    svgPath: 'M24.64 22.56c-.39.14-.64.52-.64.94c0 1.12-.93 2.03-2.06 2c-1.16-.03-2.02-1.07-1.93-2.23c.03-.42.15-.83.34-1.2l4.1-7.87c.02-.03.03-.06.05-.1c.33-.82.5-1.69.5-2.59c.01-3.8-2.97-6.89-6.77-7.02C14.27 4.38 11 7.56 11 11.5c0 .7.1 1.38.3 2.03c-.12-.01-.25-.02-.37-.02c-2.81 0-5.07 2.36-4.92 5.2a4.93 4.93 0 0 0 4.65 4.65c2.84.15 5.2-2.11 5.2-4.92c0-1.33-.53-2.54-1.39-3.43c-.35-.36-.66-.75-.89-1.19c-.38-.71-.58-1.5-.58-2.32c0-2.76 2.24-5 5-5a5.002 5.002 0 0 1 4.66 6.82l-4.08 7.83c-.38.72-.58 1.54-.58 2.35c0 2.21 1.79 4 4 4s4-1.79 4-4c0-.67-.66-1.18-1.36-.94m-13.71-1.18C9.31 21.38 8 20.06 8 18.45s1.31-2.93 2.93-2.93s2.93 1.31 2.93 2.93s-1.32 2.93-2.93 2.93',
    element: 'fire',
    elementTitle: 'Огонь',
    color: '#f57c00',
    bgGradient: 'linear-gradient(135deg, #ffa726 0%, #e65100 100%)',
    dates: '23 июл – 23 авг'
  },
  {
    key: 'virgo',
    title: 'Дева',
    symbol: '♍',
    svgPath: 'M28.62 16.99v-3.33c0-2.57-2.09-4.67-4.67-4.67c-.99 0-1.91.31-2.67.84v-.16c0-2.21-1.79-4-4-4a4 4 0 0 0-3 1.36a4 4 0 0 0-3-1.36a4 4 0 0 0-3 1.36a4 4 0 0 0-3-1.36c-.55 0-1 .45-1 1s.45 1 1 1c1.1 0 2 .9 2 2v12c0 .55.45 1 1 1s1-.45 1-1v-12c0-1.1.9-2 2-2s2 .9 2 2v12c0 .55.45 1 1 1s1-.45 1-1v-12c0-1.1.9-2 2-2s2 .9 2 2v7.32a6.07 6.07 0 0 0 2.98 5.22l-2.13 1.57a1.003 1.003 0 0 0 .6 1.81c.21 0 .41-.06.59-.2l2.63-1.94l2.63 1.94c.18.13.39.2.59.2a1.005 1.005 0 0 0 .6-1.81l-2.13-1.57a6.07 6.07 0 0 0 2.98-5.22m-2 0c0 1.47-.8 2.84-2.09 3.55l-.58.33l-.58-.33a4.07 4.07 0 0 1-2.09-3.55v-3.33c0-1.47 1.2-2.67 2.67-2.67s2.67 1.2 2.67 2.67z',
    element: 'earth',
    elementTitle: 'Земля',
    color: '#689f38',
    bgGradient: 'linear-gradient(135deg, #9ccc65 0%, #558b2f 100%)',
    dates: '24 авг – 23 сен'
  },
  {
    key: 'libra',
    title: 'Весы',
    symbol: '♎',
    svgPath: 'M20.9 21H25c.55 0 1-.45 1-1s-.45-1-1-1h-2.07c.7-1.2 1.07-2.57 1.07-4c0-4.41-3.59-8-8-8s-8 3.59-8 8c0 1.43.37 2.8 1.07 4H7c-.55 0-1 .45-1 1s.45 1 1 1h4.1c.41 0 .77-.25.93-.62c.15-.37.06-.81-.23-1.09A5.97 5.97 0 0 1 10 15c0-3.31 2.69-6 6-6s6 2.69 6 6c0 1.63-.64 3.15-1.8 4.29c-.29.28-.38.71-.23 1.09c.16.37.52.62.93.62M6 24c0 .55.45 1 1 1h18c.55 0 1-.45 1-1s-.45-1-1-1H7c-.55 0-1 .45-1 1',
    element: 'air',
    elementTitle: 'Воздух',
    color: '#3949ab',
    bgGradient: 'linear-gradient(135deg, #5c6bc0 0%, #283593 100%)',
    dates: '24 сен – 23 окт'
  },
  {
    key: 'scorpio',
    title: 'Скорпион',
    symbol: '♏',
    svgPath: 'm27.55 18.67l-2-2.12a.76.76 0 0 0-.55-.24c-.21 0-.4.09-.55.24l-2 2.12c-.28.3-.27.78.03 1.06s.78.27 1.06-.03l.46-.48v2.3a1.5 1.5 0 0 1-3-.02V11c0-2.21-1.79-4-4-4a4 4 0 0 0-3 1.36A4 4 0 0 0 11 7a4 4 0 0 0-3 1.36A4 4 0 0 0 5 7c-.55 0-1 .45-1 1s.45 1 1 1c1.1 0 2 .9 2 2v13c0 .55.45 1 1 1s1-.45 1-1V11c0-1.1.9-2 2-2s2 .9 2 2v13c0 .55.45 1 1 1s1-.45 1-1V11c0-1.1.9-2 2-2s2 .9 2 2v10.5c0 1.93 1.57 3.5 3.5 3.5s3.5-1.57 3.5-3.5v-2.28l.45.48a.75.75 0 0 0 1.06.04c.31-.29.32-.76.04-1.07',
    element: 'water',
    elementTitle: 'Вода',
    color: '#8e24aa',
    bgGradient: 'linear-gradient(135deg, #ab47bc 0%, #6a1b9a 100%)',
    dates: '24 окт – 22 ноя'
  },
  {
    key: 'sagittarius',
    title: 'Стрелец',
    symbol: '♐',
    svgPath: 'M25 7v-.1c0-.02 0-.03-.01-.05c0-.02 0-.03-.01-.05c0-.02-.01-.03-.01-.05c0-.01-.01-.03-.01-.04c0-.02-.01-.03-.02-.05c-.01-.01-.01-.03-.02-.04c-.01-.02-.01-.03-.02-.04s-.01-.03-.02-.04a.1.1 0 0 1-.02-.04c-.01-.01-.02-.03-.03-.04c-.01-.02-.02-.03-.03-.04l-.03-.03a1 1 0 0 0-.14-.14c-.01-.01-.02-.02-.03-.02c-.02-.01-.03-.02-.05-.03c-.01-.01-.03-.02-.04-.03a.1.1 0 0 0-.04-.02c-.01-.01-.03-.01-.04-.02c-.02-.01-.03-.01-.05-.02c-.01-.01-.03-.01-.04-.02c-.02-.01-.03-.01-.05-.02c-.01 0-.03-.01-.04-.01c-.02 0-.03-.01-.05-.01s-.03-.01-.05-.01s-.03-.01-.05-.01H15c-.55 0-1 .45-1 1s.45 1 1 1h6.59L13 16.59l-2.29-2.29a.996.996 0 1 0-1.41 1.41L11.59 18L6.3 23.29a.996.996 0 0 0 0 1.41c.19.2.44.3.7.3s.51-.1.71-.29l5.29-5.3l2.29 2.29c.2.2.45.3.71.3s.51-.1.71-.29a.996.996 0 0 0 0-1.41l-2.3-2.3L23 9.41V16c0 .55.45 1 1 1s1-.45 1-1z',
    element: 'fire',
    elementTitle: 'Огонь',
    color: '#d81b60',
    bgGradient: 'linear-gradient(135deg, #ec407a 0%, #ad1457 100%)',
    dates: '23 ноя – 21 дек'
  },
  {
    key: 'capricorn',
    title: 'Козерог',
    symbol: '♑',
    svgPath: 'M21.5 14.25c-1.33 0-2.55.47-3.5 1.26v-5.26c0-2.76-2.24-5-5-5c-1.49 0-2.82.65-3.74 1.69A4.01 4.01 0 0 0 6 5.25c-.55 0-1 .45-1 1s.45 1 1 1c1.1 0 2 .9 2 2v12c0 .55.45 1 1 1s1-.45 1-1v-11c0-1.65 1.35-3 3-3s3 1.35 3 3v11c0 1.93-1.57 3.5-3.5 3.5c-.55 0-1 .45-1 1s.45 1 1 1c2.22 0 4.14-1.32 5.01-3.22c1 1.06 2.42 1.72 3.99 1.72c3.03 0 5.5-2.47 5.5-5.5s-2.47-5.5-5.5-5.5m0 9c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5s3.5 1.57 3.5 3.5s-1.57 3.5-3.5 3.5',
    element: 'earth',
    elementTitle: 'Земля',
    color: '#5d4037',
    bgGradient: 'linear-gradient(135deg, #8d6e63 0%, #3e2723 100%)',
    dates: '22 дек – 20 янв'
  },
  {
    key: 'aquarius',
    title: 'Водолей',
    symbol: '♒',
    svgPath: 'M25.34 14.23c.19.17.43.25.66.25c.27 0 .53-.11.71-.32c.36-.4.33-1.02-.07-1.38l-3.33-3.02a.97.97 0 0 0-1.31 0l-2.59 2.35c-.05.04-.12.04-.17 0l-2.59-2.35a.97.97 0 0 0-1.31 0l-2.59 2.35c-.05.04-.12.04-.17 0L9.99 9.76a.97.97 0 0 0-1.31 0l-3.33 3.02c-.4.36-.43.98-.07 1.38s.98.43 1.38.07l2.59-2.35c.05-.04.12-.04.17 0l2.6 2.35c.37.34.94.34 1.31 0l2.59-2.35c.05-.04.12-.04.17 0l2.59 2.35c.37.34.94.34 1.31 0l2.59-2.35c.05-.04.12-.04.17 0zm0 8.01c.19.17.43.25.66.25c.27 0 .53-.11.72-.32c.36-.4.33-1.02-.07-1.38l-3.33-3.02a.97.97 0 0 0-1.31 0l-2.59 2.35c-.05.04-.12.04-.17 0l-2.59-2.35a.97.97 0 0 0-1.31 0l-2.59 2.35c-.05.04-.12.04-.17 0L10 17.77a.97.97 0 0 0-1.31 0l-3.33 3.02c-.4.36-.43.98-.07 1.38s.98.43 1.38.07l2.59-2.35c.05-.04.12-.04.17 0l2.59 2.35c.37.34.94.34 1.31 0l2.59-2.35c.05-.04.12-.04.17 0l2.59 2.35c.37.34.94.34 1.31 0l2.59-2.35c.05-.04.12-.04.17 0z',
    element: 'air',
    elementTitle: 'Воздух',
    color: '#00acc1',
    bgGradient: 'linear-gradient(135deg, #26c6da 0%, #00838f 100%)',
    dates: '21 янв – 19 фев'
  },
  {
    key: 'pisces',
    title: 'Рыбы',
    symbol: '♓',
    svgPath: 'M25 15h-3.96c.22-2.69 1.32-5.21 3.22-7.33a.998.998 0 1 0-1.49-1.33c-1.2 1.33-2.13 2.83-2.77 4.44c-.54 1.36-.87 2.78-.97 4.22h-6.07c-.1-1.45-.43-2.86-.97-4.22c-.63-1.61-1.56-3.11-2.75-4.45a.998.998 0 1 0-1.49 1.33c1.9 2.13 3 4.65 3.22 7.33H7c-.55 0-1 .45-1 1s.45 1 1 1h3.96c-.22 2.69-1.32 5.21-3.22 7.33a1 1 0 0 0 .08 1.41c.19.19.43.27.67.27c.28 0 .55-.11.75-.33c1.19-1.34 2.12-2.83 2.76-4.44c.54-1.36.87-2.78.97-4.22h6.07c.1 1.45.43 2.86.97 4.22a14.9 14.9 0 0 0 2.76 4.44c.2.22.47.33.75.33c.24 0 .47-.08.66-.25c.41-.37.45-1 .08-1.41c-1.9-2.13-3-4.65-3.22-7.33H25c.55 0 1-.45 1-1S25.55 15 25 15',
    element: 'water',
    elementTitle: 'Вода',
    color: '#5e35b1',
    bgGradient: 'linear-gradient(135deg, #7e57c2 0%, #4527a0 100%)',
    dates: '20 фев – 20 мар'
  },
];

/**
 * Calculates western zodiac sign key ('aries', 'pisces', etc.) by day and month (1-12)
 */
export function getZodiacSignFromDate(day: number, month: number): string {
  if ((month === 1 && day >= 21) || (month === 2 && day <= 19)) return 'aquarius'; // 21 янв - 19 фев
  if ((month === 2 && day >= 20) || (month === 3 && day <= 20)) return 'pisces'; // 20 фев - 20 мар
  if ((month === 3 && day >= 21) || (month === 4 && day <= 20)) return 'aries'; // 21 мар - 20 апр
  if ((month === 4 && day >= 21) || (month === 5 && day <= 21)) return 'taurus'; // 21 апр - 21 мая
  if ((month === 5 && day >= 22) || (month === 6 && day <= 21)) return 'gemini'; // 22 мая - 21 июн
  if ((month === 6 && day >= 22) || (month === 7 && day <= 22)) return 'cancer'; // 22 июн - 22 июл
  if ((month === 7 && day >= 23) || (month === 8 && day <= 23)) return 'leo'; // 23 июл - 23 авг
  if ((month === 8 && day >= 24) || (month === 9 && day <= 23)) return 'virgo'; // 24 авг - 23 сен
  if ((month === 9 && day >= 24) || (month === 10 && day <= 23)) return 'libra'; // 24 сен - 23 окт
  if ((month === 10 && day >= 24) || (month === 11 && day <= 22)) return 'scorpio'; // 24 окт - 22 ноя
  if ((month === 11 && day >= 23) || (month === 12 && day <= 21)) return 'sagittarius'; // 23 ноя - 21 дек
  if ((month === 12 && day >= 22) || (month === 1 && day <= 20)) return 'capricorn'; // 22 дек - 20 янв
  return '';
}

/**
 * Normalizes any string (Russian name or latin key) to canonical latin key
 */
export function normalizeZodiacKey(val: string | null | undefined): string {
  if (!val) return '';
  const clean = val.trim().toLowerCase();
  const byKey = ZODIAC_SIGNS.find(z => z.key.toLowerCase() === clean);
  if (byKey) return byKey.key;
  const byTitle = ZODIAC_SIGNS.find(z => z.title.toLowerCase() === clean);
  if (byTitle) return byTitle.key;

  if (clean.startsWith('овен') || clean.startsWith('овн')) return 'aries';
  if (clean.startsWith('тел')) return 'taurus';
  if (clean.startsWith('близ')) return 'gemini';
  if (clean.startsWith('рак')) return 'cancer';
  if (clean.startsWith('лев') || clean.startsWith('льв')) return 'leo';
  if (clean.startsWith('дев')) return 'virgo';
  if (clean.startsWith('вес')) return 'libra';
  if (clean.startsWith('скорп')) return 'scorpio';
  if (clean.startsWith('стрел')) return 'sagittarius';
  if (clean.startsWith('козер')) return 'capricorn';
  if (clean.startsWith('водол')) return 'aquarius';
  if (clean.startsWith('рыб')) return 'pisces';
  return '';
}

/**
 * Returns Russian title for a zodiac key or Russian name
 */
export function getZodiacTitle(keyOrTitle: string | null | undefined): string {
  const key = normalizeZodiacKey(keyOrTitle);
  const found = ZODIAC_SIGNS.find(z => z.key === key);
  return found ? found.title : (keyOrTitle || '');
}

/**
 * Returns full ZodiacSign object
 */
export function getZodiacSign(keyOrTitle: string | null | undefined): ZodiacSign | undefined {
  const key = normalizeZodiacKey(keyOrTitle);
  return ZODIAC_SIGNS.find(z => z.key === key);
}

/**
 * Returns unicode astrological symbol (♈, ♉, etc.)
 */
export function getZodiacSymbol(keyOrTitle: string | null | undefined): string {
  const sign = getZodiacSign(keyOrTitle);
  return sign ? sign.symbol : '✨';
}

/**
 * Returns SVG path data for Microsoft Fluent zodiac icon
 */
export function getZodiacSvgPath(keyOrTitle: string | null | undefined): string {
  const sign = getZodiacSign(keyOrTitle);
  return sign ? sign.svgPath : '';
}

